import { Deserializable } from '../../../lib/models/deserializable';

export class OutstandingDebt implements Deserializable {
  public OutstandingDebtID: number;
  public BalanceCurrentlyOutstanding?: number;
  public CreditLimitOrOriginalAmount?: number;
  public DebtOutgoingTypeCode: string;
  public MonthlyPayment?: number;
  public MortgagePayOffCode: string;
  public NameOfLender: string;
  public DebtIdentifier?: string;
  public OutstandingDetails: string;
  public OverdraftLimit?: number;
  public CreatedDate?: Date;
  public IsPayedOffWithMortgage: string;
  public IsSecuredAgainstProperty: string;
  public AccountNumber: string;
  public DrawDownYear?: number;
  public RateTypeCode: string;
  public CurrentInterestRate: string;
  public RefinanceCode: string;
  public InterestOnlyCode: string;
  public BranchName: string;
  public InstitutionCode: string;
  public IsMortgageHeldOnCurrentPropertyCode: string;
  public MortgageAccountNSC: string;
  public RequestedMortgageOnPropertyCode: string;
  public PropertyToBeSoldPriorToDrawDownCode: string;
  public NoOfMonthlyRepaymentsRemaining?: number;
  public IsDeleted: boolean;
  public IsIgnored?: boolean;
  public ApplicantOrderIds = new Array<number>();

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
